import { render, staticRenderFns } from "./PreviewCampaignPopup.vue?vue&type=template&id=c873cb1c&"
import script from "./PreviewCampaignPopup.vue?vue&type=script&lang=js&"
export * from "./PreviewCampaignPopup.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCampaignPopup.vue?vue&type=style&index=0&id=c873cb1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports